import { stack } from '@flipster/styled-system/patterns';

import { Button, CheckItem } from './button';
import { Dropdown } from './dropdown';
import DownloadIcon from './icons/download-icon.svg';
import OpenNewTabIcon from './icons/open-new-tab-icon.svg';
import ScreenshotIcon from './icons/screenshot-icon.svg';
import { useTvHeaderContext } from './index';

export const Screenshot = () => {
  const tv = useTvHeaderContext();

  const onClickDownloadScreenshot = async () => {
    if (!tv.enabled || !tv.widget) return;
    const screenshotCanvas = await tv.widget?.takeClientScreenshot();
    const linkElement = document.createElement('a');
    linkElement.download = `flipster-${tv.symbol}-${new Date().toISOString()}.png`;
    linkElement.href = screenshotCanvas.toDataURL(); // Alternatively, use `toBlob` which is a better API
    linkElement.dataset.downloadurl = ['image/png', linkElement.download, linkElement.href].join(':');
    document.body.appendChild(linkElement);
    linkElement.click();
    document.body.removeChild(linkElement);
  };

  const onClickNewTabScreenshot = () => {
    if (!tv.enabled) return;
    const handler = (id: string) => {
      window.open(`https://www.tradingview.com/x/${id}`, '_blank', 'noopener,noreferrer');
      tv.widget?.unsubscribe('onScreenshotReady', handler);
    };
    tv.widget?.subscribe('onScreenshotReady', handler);
    tv.widget?.takeScreenshot();
  };

  return (
    <Dropdown
      withClickClose
      trigger={
        <Button>
          <ScreenshotIcon width={26} height={26} />
        </Button>
      }
    >
      <div className={stack({ gap: 6 })}>
        <CheckItem onClick={onClickDownloadScreenshot}>
          <DownloadIcon />
          Download image
        </CheckItem>
        <CheckItem onClick={onClickNewTabScreenshot}>
          <OpenNewTabIcon />
          Open in new tab
        </CheckItem>
      </div>
    </Dropdown>
  );
};
